
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const BelleRecyclage = () => {
  const services = [
    "Collecte et tri de déchets industriels",
    "Recyclage de métaux",
    "Valorisation de déchets",
    "Services aux entreprises"
  ];

  return (
    <SiteDetailPage
      title="Belle Recyclage - Recyclage Métaux Industriels Rodez (12000)"
      description="Belle Recyclage à Rodez - Spécialiste du recyclage et de la valorisation des déchets industriels et métalliques en Aveyron. Expert en métaux."
      proximityInfo="Centre de recyclage industriel stratégiquement situé à Rodez, au service des entreprises de l'Aveyron et des départements limitrophes."
      address="Zone d'activité"
      postalCode="12000"
      city="Rodez"
      phone="05.65.42.18.90"
      email="contactgfe@groupefabre.com"
      website="https://www.belle-recyclage.fr"
      services={services}
      coordinates={{ lat: 44.3498, lng: 2.5757 }}
      isMiniSite={true}
    />
  );
};

export default BelleRecyclage;
